var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIconAdvancedFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32714 13.9928C0.983894 14.0129 0.646329 13.8975 0.385623 13.6708C-0.128541 13.1476 -0.128541 12.3025 0.385623 11.7792L11.6441 0.38969C12.1789 -0.11654 13.0181 -0.0883993 13.5185 0.452599C13.971 0.941821 13.9973 1.69377 13.5802 2.21418L2.25537 13.6708C1.99803 13.8942 1.66588 14.0095 1.32714 13.9928Z",
    fill: "#868D96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5724 13.9928C12.2245 13.9913 11.8911 13.8516 11.6441 13.6037L0.385579 2.21413C-0.0907669 1.6514 -0.0260051 0.804517 0.530256 0.322585C1.02673 -0.107528 1.75894 -0.107528 2.25537 0.322585L13.5802 11.7121C14.1149 12.2185 14.1425 13.0675 13.642 13.6083C13.622 13.6298 13.6015 13.6506 13.5802 13.6708C13.3029 13.9147 12.938 14.0313 12.5724 13.9928Z",
    fill: "#868D96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconAdvancedFilter);
export default __webpack_public_path__ + "static/media/crossIconAdvancedFilter.6e57c5f85cdade3c811d5ea31145a23a.svg";
export { ForwardRef as ReactComponent };